module.exports = __webpack_public_path__ + "img/vini-trackerlogov2.8dc20d37.png";